import { Route, Routes, Navigate } from "react-router-dom";
import { getFilteredRoutes } from "../../constants/routes";
import { useEffect, useState } from "react";
import { getAuthTokenData } from "../../utils/tokenUtils";

const Index: React.FC = () => {
  const [role, setRole] = useState<string | null>(null);

  useEffect(() => {
    const { role } = getAuthTokenData();
    setRole(role);
  }, []);

  return (
    <Routes>
      {getFilteredRoutes(role as string).map((route, i) => (
        <Route key={i} path={route.path} element={<route.component />} />
      ))}
      {/* <Route path="/" element={<Navigate to="/dashboard" />} /> */}
    </Routes>
  );
};

export default Index;
